/* 111 + 113 (Kevin/Arash, 2026-10-13).
   A) Phones: a product card that has a video (color products) shows its photo first, then after the card has been
      mostly on screen for DELAY ms, the video fades in (muted, looping) and stops when the card leaves the screen.
      113: the video is loaded as the card approaches the screen (so it is ready when it plays), and only fades in
      once a real frame is on screen (no black or half-loaded flash), with a slower crossfade.
   B) Product pages, all screen sizes (113): a fullscreen button on product videos, and if the phone blocks
      autoplay (iPhone Low Power Mode, data saver) the video starts on the first tap anywhere on the page. */
(function () {
  var DELAY = 1200, VISIBLE = 0.6, FADE = '.7s';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = document.createElement('style');
  css.textContent =
    '.pc-card-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity ' + FADE + ' ease;pointer-events:none;z-index:1;background:transparent}' +
    '.pc-card-video.is-on{opacity:1}' +
    '.pc-fs-btn{position:absolute;right:12px;bottom:12px;z-index:5;width:40px;height:40px;border:0;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
    '.pc-fs-btn:hover{background:rgba(0,0,0,.75)}';
  document.head.appendChild(css);

  /* Fade a video in only after a frame has actually been painted. */
  function showWhenPainted(v) {
    if (v._pcShown) return;
    var on = function () { v._pcShown = true; v.classList.add('is-on'); };
    if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(function () { on(); });
    else v.addEventListener('timeupdate', function t() { if (v.currentTime > 0) { v.removeEventListener('timeupdate', t); on(); } });
  }

  /* ── A) phone product cards ── */
  if (!reduce && window.matchMedia && 'IntersectionObserver' in window && window.matchMedia('(max-width: 767px)').matches) {
    var make = function (el) {
      var v = el._pcVideo;
      if (v) return v;
      v = document.createElement('video');
      v.className = 'pc-card-video';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'auto');
      v.src = el.getAttribute('data-pc-card-video');
      el.appendChild(v);
      el._pcVideo = v;
      return v;
    };
    var stop = function (el) {
      clearTimeout(el._pcTimer);
      var v = el._pcVideo;
      if (v) { v.classList.remove('is-on'); v._pcShown = false; v.pause(); }
    };
    var start = function (el) {
      var v = make(el);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      showWhenPainted(v);
    };
    // Load the clip while the card is still just below the screen, so it's ready when it starts.
    var pre = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { make(e.target); pre.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 400px 0px' });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        if (e.isIntersecting && e.intersectionRatio >= VISIBLE) {
          clearTimeout(el._pcTimer);
          el._pcTimer = setTimeout(function () { start(el); }, DELAY);
        } else {
          stop(el);
        }
      });
    }, { threshold: [0, VISIBLE] });
    var scan = function () {
      document.querySelectorAll('[data-pc-card-video]:not([data-pc-watched])').forEach(function (el) {
        el.setAttribute('data-pc-watched', '');
        pre.observe(el);
        io.observe(el);
      });
    };
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  /* ── B) product page videos: fullscreen button + start on first tap if autoplay was blocked ── */
  var FS_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
  function goFull(v) {
    if (v.requestFullscreen) return v.requestFullscreen();
    if (v.webkitEnterFullscreen) return v.webkitEnterFullscreen(); // iPhone
    if (v.webkitRequestFullscreen) return v.webkitRequestFullscreen();
  }
  function setup(wrap) {
    var v = wrap.querySelector('video');
    if (!v || wrap.hasAttribute('data-pc-fs')) return;
    wrap.setAttribute('data-pc-fs', '');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pc-fs-btn';
    b.setAttribute('aria-label', 'View video fullscreen');
    b.innerHTML = FS_ICON;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      goFull(v);
    });
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    wrap.appendChild(b);
  }
  function scanMedia() {
    document.querySelectorAll('video-media').forEach(function (w) {
      if (w.closest('[data-pc-card-video]')) return;
      setup(w);
    });
  }
  scanMedia();
  // The theme swaps the video in when it scrolls into view, so watch for it.
  new MutationObserver(scanMedia).observe(document.body, { childList: true, subtree: true });

  // Autoplay blocked by the phone: start any suspended product video on the first tap.
  var kick = function () {
    document.querySelectorAll('video-media[autoplay] video').forEach(function (v) {
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  };
  document.addEventListener('touchstart', kick, { once: true, passive: true });
  document.addEventListener('click', kick, { once: true });
})();
